<template>
  <div class="discussion-rating-component">
    <button
      class="vote-button"
      @click="upVote"
    >
      <icon
        :name="iconName.up"
        :variant="'7b7b7b'"
        class="up"
      />
    </button>
    <label-text
      :inline="true"
      :size="'xs'"
    >
      {{ scoreText }}
    </label-text>
    <button
      class="vote-button"
      @click="downVote"
    >
      <icon
        :name="iconName.down"
        :variant="'7b7b7b'"
        class="down"
      />
    </button>
  </div>
</template>

<script>
import Icon from '@/components/singletons/icon.vue';
import LabelText from '@/components/ui/label-text.vue';

import RatingMixin from '@/mixins/rating';

export default {
  name: 'DiscussionRating',
  components: {
    Icon,
    LabelText,
  },
  mixins: [RatingMixin],
  props: {
    asset: {
      type: Object,
    },
    category: {
      type: Object,
    },
    discussion: {
      type: Object,
    },
    parentDiscussion: {
      type: Object,
    },
  },
  data() {
    return {
      newScore: null,
    };
  },
  computed: {
    analyticsParams() {
      return {
        asset: this.asset,
        category: this.category,
        parentDiscussionId: this.parentDiscussion?.id,
        discussionId: this.discussion?.id,
      };
    },
    iconName() {
      const up = this.rating?.rating === 1 ? 'thumb-filled' : 'thumb-outline';
      const down = this.rating?.rating === 0 ? 'thumb-filled' : 'thumb-outline';
      return {
        up,
        down,
      };
    },
    rateableType() {
      return 'Discussion';
    },
    rateableId() {
      return this.discussion?.id;
    },
    scoreText() {
      if (this.newScore !== null && this.newScore !== undefined) {
        return this.newScore;
      } else {
        return (this.discussion.voteCount || 0);
      }
    },
  },
  methods: {
    downVote() {
      let removedRating;
       if (this.rating?.rating === 0) {
        removedRating = true;
      }
      const params = {
        ...this.analyticsParams,
        rating: 'Downvote',
      };
      if (removedRating) {
        this.$analytics.events.removedDiscussionRating(params);
      } else {
        this.$analytics.events.ratedDiscussion(params);
      }
      this.rate('down', this.discussion).then(resp => this.handleNewDiscussionVoteCount(resp));
    },
    handleNewDiscussionVoteCount({ data }) {
      if (data) {
        this.newScore = data.score;
      }
    },
    upVote() {
      let removedRating;
      if (this.rating?.rating === 1) {
        removedRating = true;
      }
      const params = {
        ...this.analyticsParams,
        rating: 'Upvote',
      };
      if (removedRating) {
        this.$analytics.events.removedDiscussionRating(params);
      } else {
        this.$analytics.events.ratedDiscussion(params);
      }
      this.rate('up', this.discussion).then(resp => this.handleNewDiscussionVoteCount(resp));
    },
  },
};
</script>

<style lang="scss" scoped>
.discussion-rating-component {
  display: flex;
  align-items: center;

  .vote-button {
    border: none;
    background: transparent;
    padding: 0 rem-calc(12);

    .up,
    .down {
      width: rem-calc(16)
    }

    .down {
      transform: rotate(180deg);
    }
  }
}
</style>
